// extracted by mini-css-extract-plugin
export default {"wrapper":"IndexPage_wrapper__5J8aQ","loadingWrapper":"IndexPage_loadingWrapper__5vFrq"};